/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * The feedback text for the student
 */
export type TaskFeedbackText = string | null;
